import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getList, remove, update, add, getNotice } from "@/api/desk/notice";
import { mapGetters } from "vuex";
export default {
  data: function data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 30,
        dialogWidth: 950,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        editBtn: true,
        excelBtn: true,
        dialogClickModal: false,
        column: [{
          label: "通知标题",
          prop: "title",
          span: 24,
          row: true,
          search: true,
          rules: [{
            required: true,
            message: "请输入通知标题",
            trigger: "blur"
          }]
        }, {
          label: "通知类型",
          type: "select",
          dicUrl: "/api/blade-system/dict/dictionary?code=notice",
          props: {
            label: "dictValue",
            value: "dictKey"
          },
          dataType: "number",
          slot: true,
          prop: "category",
          search: true,
          rules: [{
            required: true,
            message: "请输入通知类型",
            trigger: "blur"
          }]
        }, {
          label: "通知时间",
          prop: "releaseTimeRange",
          type: "datetime",
          format: "yyyy-MM-dd hh:mm:ss",
          valueFormat: "yyyy-MM-dd hh:mm:ss",
          searchRange: true,
          hide: true,
          addDisplay: false,
          editDisplay: false,
          viewDisplay: false,
          search: true,
          rules: [{
            required: true,
            message: "请输入通知时间",
            trigger: "blur"
          }]
        }, {
          label: "通知日期",
          prop: "releaseTime",
          type: "date",
          format: "yyyy-MM-dd hh:mm:ss",
          valueFormat: "yyyy-MM-dd hh:mm:ss",
          rules: [{
            required: true,
            message: "请输入通知日期",
            trigger: "click"
          }]
        }, {
          label: "通知内容",
          prop: "content",
          component: 'AvueUeditor',
          options: {
            action: '/api/blade-resource/oss/endpoint/put-file',
            props: {
              res: "data",
              url: "link"
            }
          },
          hide: true,
          minRows: 6,
          span: 24
        }]
      },
      data: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(["permission"])), {}, {
    permissionList: function permissionList() {
      return {
        addBtn: this.vaildData(this.permission.notice_add, false),
        viewBtn: this.vaildData(this.permission.notice_view, false),
        delBtn: this.vaildData(this.permission.notice_delete, false),
        editBtn: this.vaildData(this.permission.notice_edit, false)
      };
    },
    ids: function ids() {
      var ids = [];
      this.selectionList.forEach(function (ele) {
        ids.push(ele.id);
      });
      return ids.join(",");
    }
  }),
  methods: {
    rowSave: function rowSave(row, done, loading) {
      var _this = this;

      add(row).then(function () {
        _this.onLoad(_this.page);

        _this.$message({
          type: "success",
          message: "操作成功!"
        });

        done();
      }, function (error) {
        window.console.log(error);
        loading();
      });
    },
    rowUpdate: function rowUpdate(row, index, done, loading) {
      var _this2 = this;

      console.log(row);
      debugger;
      update(row).then(function () {
        _this2.onLoad(_this2.page);

        _this2.$message({
          type: "success",
          message: "操作成功!"
        });

        done();
      }, function (error) {
        window.console.log(error);
        loading();
      });
    },
    rowDel: function rowDel(row) {
      var _this3 = this;

      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return remove(row.id);
      }).then(function () {
        _this3.onLoad(_this3.page);

        _this3.$message({
          type: "success",
          message: "操作成功!"
        });
      });
    },
    searchReset: function searchReset() {
      this.query = {};
      this.onLoad(this.page);
    },
    searchChange: function searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    selectionChange: function selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear: function selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    handleDelete: function handleDelete() {
      var _this4 = this;

      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }

      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return remove(_this4.ids);
      }).then(function () {
        _this4.onLoad(_this4.page);

        _this4.$message({
          type: "success",
          message: "操作成功!"
        });

        _this4.$refs.crud.toggleSelection();
      });
    },
    beforeOpen: function beforeOpen(done, type) {
      var _this5 = this;

      if (["edit", "view"].includes(type)) {
        getNotice(this.form.id).then(function (res) {
          _this5.form = res.data.data;
        });
      }

      done();
    },
    currentChange: function currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange: function sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange: function refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad: function onLoad(page) {
      var _this6 = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var releaseTimeRange = this.query.releaseTimeRange;

      var values = _objectSpread({}, params);

      if (releaseTimeRange) {
        values = _objectSpread(_objectSpread({}, params), {}, {
          releaseTime_datege: releaseTimeRange[0],
          releaseTime_datelt: releaseTimeRange[1]
        }, this.query);
        values.releaseTimeRange = null;
      }

      this.loading = true;
      getList(page.currentPage, page.pageSize, values).then(function (res) {
        var data = res.data.data;
        _this6.page.total = data.total;
        _this6.data = data.records;
        _this6.loading = false;

        _this6.selectionClear();
      });
    }
  }
};